import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.jpg')}
					title={"5 Easy Steps to Creating a Facebook Business Page"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 28 April 2020  //  Posted in <strong>Marketing</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									5 Easy Steps to Creating a Facebook Business Page
								</div>
								
								<p>
Whether you like it or not, Facebook has become a part of our daily routine - you may be a Facebook user before bed, when you wake up, when you’re eating your breakfast, when you’re in line for your takeaway coffee, or all of the above! In fact, over <a href="https://www.facebook.com/zuck/posts/10107243286682221"> 1.62 billion </a> people use Facebook <i> every day</i>. </p>
								
			
<h3>This begs the question: are you making the most of this fantastic FREE digital platform for your business?</h3>
<br></br>
<p>If you’re yet to join the masses of businesses on Facebook, then read on! We're here to help get your Facebook Business set up in only 5 easy steps. If at any point you get stuck, feel free to <a href="https://www.moshi.com.au/contact-us"> get in touch </a> with our team.  </p>

<ul>
<li>Step 1: Creating Your Facebook Business Page</li>
<li>Step 2: Branding Your Facebook Business Page</li>
<li>Step 3: Business Page Settings and Templates</li>
<li>Step 4: Setting Up Shop</li>
<li>Step 5: Spread the Word!</li>
</ul>
<br></br><hr></hr>
<br></br>

<h2>Step 1: Creating Your Facebook Business Page</h2> 

<p> To start with, you must have a personal login to Facebook. Unfortunately you can’t just create a Facebook Business Page without a user connected, but you can always add another page Administrator later and remove yourself after (this is covered further down).</p>
<p>Once you have logged into your Facebook account, locate the ‘+’ symbol in the top right of your browser. Select ‘Page’. </p>

<img src={require('./image-2.png')} alt="Create Your Page" height="350" width= "650" className="align-centre" align="centre" />
<p>You will be prompted to choose between a Business or Brand, or Community or Public Figure page. Most of you will be selling products or services, so select <b>Business or Brand</b>.</p>
<p>You will then be prompted to enter in the name of your page, and select the category it falls into. 
<i>Make sure you check the name is correct before proceeding, as this can be difficult to change later.</i></p>
<p> You must also enter in an address - but don’t worry, you can choose to not show this later on.</p> 

<br></br><hr></hr>
<br></br>

<h2>Step 2: Branding Your Facebook Business Page</h2> 

<p> The next step is a great opportunity for you to create a consistent brand between cover image, logo and profile image.</p> 
<p>Your profile picture should be a minimum of 180x180 pixels, but we recommend 400x400 and above for sharper imagery. Try to keep your logo centred in your profile image, as <b>Facebook crops your profile picture down to a circle</b>.</p> 
<p>Your cover image should be 828 x 465 pixels for optimal fitting. If you choose to add text to your cover image, keep in mind that the image will respond to mobile view. Make sure to test how it looks across all platforms. </p>
<p>Cover images also allow for video upload - this is a great way to add a professional edge to your Facebook Business page and stand out from the competition! Just make sure to choose a high quality video.</p>

<img src={require('./image-3.png')} alt="A Great Example of Consistent Branding" height="280" width= "480" className="align-centre" align="centre" />


<br></br><hr></hr>
<br></br>

<h2>Step 3: Business Page Settings and Templates</h2> 
<img src={require('./image-5.png')} alt="Important Areas of Your Page" height="330" width= "600" className="align-centre" align="centre" />
<p>There are three primary areas you need to become familiar with in the next step.</p>
<ul>
<li>Page Settings/Edit Page Info</li>
<li>Insights</li>
<li>Add a Button</li>
</ul>

<br></br>

<h4>Page Settings:</h4>
<p>Firstly, head to Page Settings, and locate ‘Template and Tabs’ on the left hand side. <b>Click on Templates -> Edit.</b></p> 
<p>This will open a whole list of templates available for you. For our example, we are a page that sells physical goods, so we will select the ‘Shopping’ template.</p>
<img src={require('./image-4.png')} alt="Page Templates Available" height="440" width= "440" className="align-centre" align="centre" />
<p>Once you’ve applied your template, you can select which tabs you would like. Simply toggle the on/off switch to change what is shown.</p> 
<p>You can also drag and drop the order of your tabs by holding down on one and dragging it to wherever you’d like.</p>
<p>From here, work your way down the list of items on the left hand menu, starting with ‘General’ and ending with ‘Page Management History’.</p> 
<b>Here’s a quick rundown of what each section means:</b>

<h5>General:</h5><p>managing settings such as tagging, age restrictions, profanity restrictions, also where you can remove your page. </p>
<h5>Messaging:</h5><p>where you can set up auto responses (recommended!)</p>
<h5>Page Info:</h5><p>the name and contact details of your business. When creating a username, try to use one that’s related to your business name, and not too long.</p>
<h5>Templates and Tabs:</h5><p>where you can change the order of your page tabs or change templates.</p>
<h5>Event Tickets:</h5><p>Accessible to those with Eventbrite accounts for synching and ease of purchase.</p>
<h5>Notifications:</h5><p>edit which notifications you receive. </p>
<h5>Advanced Messaging:</h5><p>manage settings for bots. </p>
<h5>Page Roles:</h5><p>this is a big one! You can give full access to someone else on Facebook here, by heading to the ‘Assign New Page Role’ area and entering their name.</p>
<p>You can then assign them access, and they will receive a notification in their regular Facebook dashboard. This step can be tricky, and doesn’t always work straight away. If you need help assigning page roles, <a href="https://www.moshi.com.au/contact-us"> get in touch. </a> </p>
<h5>People and Other Pages:</h5><p>gives you permission to ban certain users from engaging with your content (providing they like your page).</p>
<h5>Instagram:</h5><p>where you connect your Instagram account for multi platform sharing.</p>
<h5>WhatsApp:</h5><p>connects your phone to your business page for seamless communication. </p>
<h5>Payments:</h5><p>make sure you select the right currency. This can’t be changed later! </p>
<h5>Page Management History:</h5><p>here’s where you can see who’s made which edits and when. </p>
<br></br>
<h4>Insights:</h4>
<p>The Insights page is located on your left hand menu of your Business Page. This page is where your page data is kept - how many likes you receive week on week, how many people engaged with your content, your reach etc.</p> 
<p>This is great for performance reports, and seeing where you could improve and where people really engaged with your posts.</p>
<br></br>
<h4>Add a Button:</h4>
<p>This is your call to action, and the first thing a user typically sees when they come across a Business Page. What action do you want them to take? Click on the button and select which option you need in order to get conversions.</p>

	
<br></br><hr></hr>
<br></br>

<h2>Step 4: Setting Up Shop</h2> 

<p>Once you’ve added your button, locate your <b>Shop</b> tab on your profile. If you haven’t rearranged your tabs, it will be under the ‘More’ arrow.</p> <p>Depending on your chosen template, you may have other options appear, like Services, Events etc. </p>						
<p>Click on 'Shop' and read the Terms and Conditions before pressing ‘Accept’.</p>
<p>From here you have two options - you can either ask people to <b>message you to purchase</b>, or you can <b>link them to a checkout page</b> on your website.</p> 
<p>If you don’t have a website, you will have to select <b>‘Message to Buy’</b>.</p> 
<img src={require('./image-6.png')} alt="Select Checkout Method" height="300" width= "700" className="align-centre" align="centre" />
<p>Once you have selected your method, it’s simply a matter of following the prompts through to the end. Facebook will prompt you for each product’s title, description, condition, price and whether it is in stock. </p>
<p>When you’ve done that, make sure to head back to ‘Page Settings’ -> ‘Templates and Tabs' and rearrange your <b>Shop</b> tab to be right next to your <b>Home</b> tab (if you haven’t already).</p> 

<br></br><hr></hr>
<br></br>

<h2>Step 5: spread the word!</h2> 

<p>Congratulations! Your Facebook Business Page is ready to go, now it's time to grow! (I had to!) </p>
<p>The easiest way to gain an audience is by using existing email lists and friends from your personal account. But if you want to take the next step (keep in mind, this is where you start spending money), then you want to start advertising your page. </p>
<b>Now, I could get into a massive 3 day long tutorial on the differences between ads, boosted posts, Instagram tagging, shopping ads, canvas ads, carousel ads and Ads Manager, but I’m going to keep things simple today.</b>


<p>For your first ad, head to your Business Page’s profile, and locate the ‘+’ button again. This time, instead of selecting ‘Page’, you want to select ‘Ad’.</p> 
<p>Depending on your chosen template, you may have other options appear, like Services, Events etc. </p>						
<b>Facebook has split out its different marketing objectives into the following categories:</b>
<img src={require('./image-7.png')} alt="Advertising Categories" height="300" width= "600" className="align-centre" align="centre" />
<p>For your first ad, you want to spread awareness that you exist, so select <b>Brand Awareness</b>. </p>
<p>From there, follow the steps to create your first ad, just make sure to triple check everything before you go live! </p>
<p>To track your ad performance easily, head back to your Facebook Business Page, and click ‘Ads Centre - All Ads’ on the left hand side.</p>
<p>Again, once you dive into the world of Facebook marketing, things can become a bit trickier.</p> 
<p>Facebook pixels, Ads Manager, Business Manager and creating ad imagery can be a massive time consumer if you’re not sure what you’re doing.</p> 
<p>If at any point you feel like you might need a hand, we’re always here to help.</p>

<h3>Good luck with your first Business Page, and get selling! </h3>


							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/FacebookBusiness/index.js